import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getStopCards({ commit }, payload = {
        paginate: '',
        query: ''}) {
        const paginate = payload.paginate,
            query = payload.query

        commit('GET_STOP_CARDS_REQUEST')

        return axios
            .get(`/stop-cards/stop-cards${paginate}${query}`)
            .then(response => {
                commit('GET_STOP_CARDS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_STOP_CARDS_FAILURE')
                handleApiError(error, 'Pobranie listy kart stop nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getStopCard(_, id) {
        return axios
            .get(`/stop-cards/stop-cards/${id}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, `Pobranie danych do karty stop ${id} nie powiodło się.`)

                return Promise.reject(error)
            })
    },
    createStopCard({ commit }, payload) {
        return axios
            .post('/stop-cards/stop-cards', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Karta stop została dodana.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie karty stop nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateStopCard({ commit }, payload) {
        return axios
            .put(`/stop-cards/stop-cards/${payload.id}`, payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Karta stop została zaktualizowana.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Aktualizacja karty stop nie powiodła się.')

                return Promise.reject(error)
            })
    },
    getStopCardErrors({ commit }) {
        return axios
            .get('/stop-cards/stop-cards/dicts/errors')
            .then(response => {
                commit('GET_ERRORS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie kodów błędów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getStopCardStatuses({ commit }) {
        return axios
            .get('/stop-cards/stop-cards/dicts/stop-card-statuses')
            .then(response => {
                commit('GET_STOP_CARDS_STATUSES_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie statusów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getWaysOfClosing({ commit }) {
        return axios
            .get('/stop-cards/stop-cards/dicts/ways-of-closing')
            .then(response => {
                commit('GET_WAYS_OF_CLOSING_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie sposobów zakończenia karty stop nie powiodło się.')

                return Promise.reject(error)
            })
    },
    generateStopCardsReport({ commit }, {
        query = '',
        userEmail
    } = {}) {
        return axios
            .get(`/stop-cards/stop-cards?report=true${query}`, {
                timeout: 120000, // 2 min
            })
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: `Raport został wysłany na adres ${userEmail}.`
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wygenerowanie raportu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    printStopCard(_, payload) {
        return axios
            .post('/stop-cards/print-stop-card', payload, {
                responseType: 'arraybuffer'
            })
            .then(response => Promise.resolve(response))
            .catch(error => {
                handleApiError(error, `Drukowanie karty stop ${payload.stopCardId} nie powiodło się.`)

                return Promise.reject(error)
            })
    },
    setStopCardsFilters({ commit }, filters) {
        commit('SET_STOP_CARDS_FILTERS', filters)
    },
    clearStopCardsFilters({ commit }) {
        commit('CLEAR_STOP_CARDS_FILTERS')
    },
}